import { Link } from "react-router-dom";
import SEO from "@/components/public/SEO";

export default function NotFoundPage() {
  return (
    <>
      <SEO title="404" description="Aradığınız sayfa bulunamadı." noindex />
      <section className="pt-40 pb-32 max-w-3xl mx-auto px-6 text-center">
        <div className="text-[11px] tracking-overline uppercase text-cc-sepia mb-5">404</div>
        <h1 className="font-serif text-6xl md:text-8xl text-cc-text mb-6">Yolunuzu kaybettiniz.</h1>
        <p className="text-cc-muted mb-10">Aradığınız sayfa burada değil. Belki Journal'da bir hikâye sizi bekliyordur.</p>
        <Link to="/" className="cc-btn">Ana sayfaya dön</Link>
      </section>
    </>
  );
}
